import React from 'react';
import { User } from 'lucide-react';
export function Sidebar() {
  return <aside className="w-[230px] flex-shrink-0 border-r border-[#0e1826] bg-[#04080f] flex flex-col h-screen overflow-y-auto" data-id="element-86">
      {/* Logo Area */}
      <div className="p-6 flex items-center gap-3" data-id="element-87">
        <div className="w-10 h-10 rounded-lg bg-[#b8a06a] flex items-center justify-center text-[#04080f] font-bold text-lg" data-id="element-88">
          DC
        </div>
        <div className="flex flex-col" data-id="element-89">
          <span className="font-bold text-[#f0ead8] leading-tight" data-id="element-90">
            DermaClinic
          </span>
          <span className="text-[10px] font-semibold tracking-wider text-[#3a5070] uppercase mt-0.5" data-id="element-91">
            3D Simulation
          </span>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-4 py-2 space-y-8" data-id="element-92">
        {/* Main Nav */}
        <div className="space-y-1" data-id="element-93">
          <div className="flex items-center gap-3 px-3 py-2 bg-[#060c18] rounded-md cursor-pointer" data-id="element-94">
            <div className="w-1.5 h-1.5 rounded-full bg-[#b8a06a]" data-id="element-95"></div>
            <span className="text-[#b8a06a] font-medium text-sm" data-id="element-96">
              Dashboard
            </span>
          </div>
        </div>

        {/* Patients Section */}
        <div data-id="element-97">
          <h3 className="px-3 text-[11px] font-semibold text-[#3a5070] tracking-wider uppercase mb-3" data-id="element-98">
            Patients
          </h3>
          <ul className="space-y-1" data-id="element-99">
            <NavItem label="New patient" data-id="element-100" />
            <NavItem label="Patient list" badge="14" data-id="element-101" />
            <NavItem label="Simulations" data-id="element-102" />
            <NavItem label="Feedback" data-id="element-103" />
          </ul>
        </div>

        {/* Marketing Section */}
        <div data-id="element-104">
          <h3 className="px-3 text-[11px] font-semibold text-[#3a5070] tracking-wider uppercase mb-3" data-id="element-105">
            Marketing
          </h3>
          <ul className="space-y-1" data-id="element-106">
            <NavItem label="Patient app link" data-id="element-107" />
            <NavItem label="Reviews" data-id="element-108" />
            <NavItem label="Campaigns" data-id="element-109" />
          </ul>
        </div>

        {/* GHL Sync Section */}
        <div data-id="element-110">
          <h3 className="px-3 text-[11px] font-semibold text-[#3a5070] tracking-wider uppercase mb-3" data-id="element-111">
            GHL Sync
          </h3>
          <ul className="space-y-1" data-id="element-112">
            <NavItem label="Pipeline sync" data-id="element-113" />
            <NavItem label="Automations" data-id="element-114" />
          </ul>
        </div>

        {/* Settings Section */}
        <div data-id="element-115">
          <h3 className="px-3 text-[11px] font-semibold text-[#3a5070] tracking-wider uppercase mb-3" data-id="element-116">
            Settings
          </h3>
          <ul className="space-y-1" data-id="element-117">
            <NavItem label="Simulator config" data-id="element-118" />
            <NavItem label="Locations" data-id="element-119" />
            <NavItem label="Plans & billing" data-id="element-120" />
          </ul>
        </div>
      </nav>

      {/* Footer */}
      <div className="p-4 mt-auto" data-id="element-121">
        <div className="bg-[#060c18] border border-[#0e1826] rounded-xl p-3 flex items-center gap-3 cursor-pointer hover:bg-[#0e1826] transition-colors" data-id="element-122">
          <div className="w-8 h-8 rounded-full bg-[#b8a06a] flex items-center justify-center text-[#04080f] font-bold text-xs flex-shrink-0" data-id="element-123">
            DC
          </div>
          <div className="flex flex-col overflow-hidden" data-id="element-124">
            <span className="text-sm font-medium text-[#f0ead8] truncate" data-id="element-125">
              DermaClinic Center
            </span>
            <span className="text-xs text-[#3a5070] truncate" data-id="element-126">
              Pro · 4 locations
            </span>
          </div>
        </div>
      </div>
    </aside>;
}
function NavItem({
  label,
  badge
}: {
  label: string;
  badge?: string;
}) {
  return <li className="flex items-center justify-between px-3 py-2 rounded-md cursor-pointer hover:bg-[#060c18] transition-colors group" data-id="element-127">
      <div className="flex items-center gap-3" data-id="element-128">
        <div className="w-1.5 h-1.5 rounded-full bg-[#3a5070] group-hover:bg-[#f0ead8] transition-colors" data-id="element-129"></div>
        <span className="text-[#3a5070] group-hover:text-[#f0ead8] font-medium text-sm transition-colors" data-id="element-130">
          {label}
        </span>
      </div>
      {badge && <span className="bg-[#0e1826] text-[#b8a06a] text-[10px] font-bold px-2 py-0.5 rounded-full" data-id="element-131">
          {badge}
        </span>}
    </li>;
}